var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuicklinksBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "quicklinks",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.934,
    height: 65.934,
    viewBox: "0 0 65.934 65.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M32.967,0A32.967,32.967,0,1,1,0,32.967,32.967,32.967,0,0,1,32.967,0Z",
    fill: "#009bad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M180.357,133.638a11.939,11.939,0,0,0,4.705,1.913l-4.76,4.76a8.577,8.577,0,0,1-12.13-12.129l8.085-8.086a8.588,8.588,0,0,1,12.13,0,2.31,2.31,0,0,1,.424.6c.016.032.035.061.049.094a2.329,2.329,0,0,1,.184.66c0,.035.007.069.01.1h0a2.331,2.331,0,0,1-.043.7c0,.011-.007.021-.01.033a2.329,2.329,0,0,1-3.923,1.113,3.9,3.9,0,0,0-3.488-1.068h0a3.893,3.893,0,0,0-2.024,1.068l-3.659,3.659,0,0-4.423,4.424a3.9,3.9,0,0,0,0,5.511,3.992,3.992,0,0,0,5.512,0Zm20.959-24.132a8.575,8.575,0,0,0-12.129,0l-4.765,4.765a12.013,12.013,0,0,1,4.707,1.911l3.367-3.367a3.99,3.99,0,0,1,5.511,0,3.9,3.9,0,0,1,0,5.511l-1.483,1.484,0,.006-6.6,6.594a3.991,3.991,0,0,1-5.511,0,2.34,2.34,0,0,0-3.309,3.309,8.575,8.575,0,0,0,12.129,0l6.6-6.6.006,0,1.482-1.484a8.575,8.575,0,0,0,0-12.129Z",
    transform: "translate(-151.778 -91.942)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicklinksBig);
export default __webpack_public_path__ + "static/media/quicklinksBig.1455ba50eca3103c22212dedb0e8e973.svg";
export { ForwardRef as ReactComponent };